import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [DragDropModule],
  exports: [DragDropModule]
})
export class MaterialModule {}
